<template>
  <div>
    <header :class="[customHeader, { 'cursor-not-allowed': disabled, 'cursor-pointer': !disabled }]" class="flex items-center" @click.prevent="toggle">
      <div class="mr-2">
        <el-switch :value="value" :disabled="disabled" />
      </div>
      <slot name="headerRight"/>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-if="value" :class="{ 'overflow-hidden': overflowHidden }">
        <div :class="customContent">
          <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'base-collapsible-switch',
  props: {
    value: Boolean,
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    overflowHidden: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {}
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    }
  },
  watch: {
    value: function (newValue) {
      if (!newValue) this.$emit('clearForm')
    }
  },
  methods: {
    toggle () {
      if (!this.disabled) this.$emit('input', !this.value)
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
